// visit parts
export const GET_VISIT_PARTS_SUCCESS = 'GET_VISIT_PARTS_SUCCESS';
export const GET_VISIT_PARTS_FAILURE = 'GET_VISIT_PARTS_FAILURE';
export const GET_VISIT_PARTS_REQUEST = 'GET_VISIT_PARTS_REQUEST';
export const CLEAR_VISIT_PARTS = 'CLEAR_VISIT_PARTS';

// visit paret
export const SELECT_VISIT_PART = 'SELECT_VISIT_PART';
export const CLEAR_SELECTED_VISIT_PART = 'CLEAR_SELECTED_VISIT_PART';
